import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useHomeProductStore } from "./reactStore/homeProduct";
import ImgBlock from "./product-card/productCard";
import "./homeListing.css";
import { zStore } from './reactStore'
import {dispatch} from './reactStore/vuexBridge'
import { getProductUrl } from '../assets/js/common'
import IDB from '.././utils/indexedDb'
import { getGetter } from './reactStore/vuexBridge'

export default function ProductCard({
  isExclusive,
  isDesktop,
  categories,
  routePath,
}) {
  const {
    products,
    fetchProducts,
    page,
    hasMore,
    isLoading,
    catIds,
    fetchCategoryInfo,
    catInfo,
    clearProducts,
  } = useHomeProductStore();

  const [productList, setProductList] = useState([]);
  const [checkCache, setCheckCache] = useState(false);
  const containerRef = useRef(null);
  const headerRef = useRef(null);
  const staticImgServer = process.env.STATIC_IMG_SERVER2;
  const MOENGAGE_EVENT = zStore.event((s) => s.MOENGAGE_EVENT)
  const GTAG_EVENT = zStore.event((s) => s.GTAG_EVENT)
  const imgBaseUrl = process.env.IMG_BASE_URL + process.env.PRODUCT_IMG;


  // Fixed header state
  const [isFixed, setIsFixed] = useState(false);
  const [isNavigate, setIsNavigate] = useState(false);
  const [headerH, setHeaderH] = useState();
  const [totalCategories, setTotalCategories] = useState([]);

  // If your site already has a fixed top navbar, set this to its height (e.g., 64)
  const OFFSET_TOP = isDesktop ? 70 : 41;

  useEffect(() => {
    IDB.get('homeListingCache').then((cache) => {
      const webcategory = getGetter('webcategory')
      if (webcategory && cache && cache?.webcategory && cache?.webcategory !== webcategory) {
        IDB.delete('homeListingCache').then()
      }
      // set({ preventRegularCall: false })
      useHomeProductStore.setState({ products: [] });
      clearProducts();
      setProductList([]);
      useHomeProductStore.setState({ catIds: [] });
      categories.find((item) => {
        if (item.url === routePath) {
          let ids = item?.categoryIds?.split(",")?.map(Number);
          setTotalCategories(ids || []);
          item?.categoryIds &&
            useHomeProductStore.setState({ catIds: ids || [] });
          if (ids?.length) {
            fetchCategoryInfo(item?.categoryIds);
            // const cache = await IDB.get('homeListingCache')
            if (cache && cache.webcategory === webcategory && cache?.products?.length) {
              useHomeProductStore.setState({ preventRegularCall: false });
              useHomeProductStore.setState({ catIds: cache.catIds })
              fetchProducts(1, true)
              setCheckCache(true)
            } else {
              fetchProducts(1);
              setCheckCache(true)
            }
          }
        }
      });
    });
  }, [routePath]);

  useEffect(() => {
    setProductList(products);
    if (products.length > 0 && checkCache) useHomeProductStore.setState({ preventRegularCall: true });
  }, [products]);

  useEffect(() => {
    if (isLoading) {
      let createId =
        productList.length === 0 && page === 1 ? "spinLoader1" : `spinLoader`;
      scrollToId(createId);
    }
  }, [isLoading]);

  useEffect(() => {
    if (isNavigate && productList.length > 0 && page === 1) {
      let createId = `productlist-${productList[0].id}`;
      // scrollToId(createId);
    }
  }, [productList, isNavigate]);

  // Measure header height (for proper stop-at-bottom behavior & spacing)
  useLayoutEffect(() => {
    if (headerRef.current) setHeaderH(headerRef.current.offsetHeight || 0);
    dispatch('WISHLIST_DATA')
    MOENGAGE_EVENT({
      eventName: 'ISCROLL_CATEGORY_CLICK',
      payload: {
        category: 'All',
        ids: catInfo.length > 0 && catInfo?.map(item => item.id).join(',') || ''
      }
    })
    GTAG_EVENT({
      eventName: 'ISCROLL_CATEGORY_CLICK',
      payload: {
        category: 'All',
        ids: catInfo.length > 0 && catInfo?.map(item => item.id).join(',') || ''
      }
    })
  }, []);

  const scrollToId = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  // Single scroll handler: handles both infinite scroll + sticky logic
  useEffect(() => {
    const onScroll = () => {
      // ----- Sticky within container -----
      const cont = containerRef.current;
      const hdr = headerRef.current;
      if (cont && hdr) {
        const rect = cont.getBoundingClientRect();
        // Fix header when container top hits viewport top (considering OFFSET_TOP)
        // and keep it fixed until the container bottom passes the header bottom.
        const shouldFix =
          rect.top <= OFFSET_TOP && rect.bottom - headerH > OFFSET_TOP;
        if (shouldFix !== isFixed) setIsFixed(shouldFix);
      }

      // ----- Infinite scroll (near bottom of page) -----
      if (!hasMore || isLoading) return;
      const scrollY = window.scrollY || window.pageYOffset;
      const viewportH = window.innerHeight;
      const docH = document.documentElement.scrollHeight;

      // Start loading next page when we're within 20% of the bottom
      if (scrollY + viewportH >= docH * 0.8 && scrollY + viewportH < docH * 0.93) {
        if (products.length > 0 && checkCache) useHomeProductStore.setState({ preventRegularCall: false });
        if (checkCache) fetchProducts(page + 1);
      }
    };

    // Run once to set initial state
    onScroll();

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [page, hasMore, isLoading, headerH, isFixed, fetchProducts]);

  const handleCategoryClick = (categoryId, ctInfo) => {
    categoryId && useHomeProductStore.setState({ catIds: categoryId });
    setIsNavigate(true);
    clearProducts();
    setProductList([]);
    if (checkCache) {
      useHomeProductStore.setState({ preventRegularCall: false })
      fetchProducts(1);
    }
    scrollToId("spinLoader");

    let payload = {}
    if (ctInfo) {
      payload = ctInfo
    } else {
      payload = {
        category: 'All',
        ids: catInfo.map(item => item.id).join(',')
      }
    }

    MOENGAGE_EVENT({
      eventName: 'ISCROLL_CATEGORY_CLICK',
      payload: payload
    })
    GTAG_EVENT({
      eventName: 'ISCROLL_CATEGORY_CLICK',
      payload: payload
    })
    let createId = `productlist-${productList[0]?.id}`;
    scrollToId(createId);
  };


  const handleEvent = (prd, position) => {
    let raw = localStorage.getItem("tss-v2__lastWidgetId");

    if (raw) {
      let parsed = JSON.parse(raw);

      if (parsed?.value) {
        parsed.value.isNavigateFromInfinite = true;
        parsed.value.prdId = `productlist-${prd.id}`;

        localStorage.setItem(
          "tss-v2__lastWidgetId",
          JSON.stringify(parsed)
        );
      }
    }
    // lastWidget.isNavigateFromInfinite = true
    const payload = {
      Product_id: Number(prd.id),
      Product_Category: String((prd.category && prd.category.name) || prd.category) || 'NA',
      Product_Name: prd.product ? String(prd.product) : 'NA',
      Product_Price: String(prd.price) || 'NA',
      Product_Artist: String((prd.artist && prd.artist.name) || prd.artist) || 'NA',
      Quantity: 1,
      Size: String(prd.size) || 'NA',
      Product_Image_URL: prd.images?.[0] ? String(imgBaseUrl + prd.images[0]) : 'NA',
      Product_URL: String(getProductUrl && getProductUrl(true, prd.product_slug, prd.gender_type)) || 'NA',
      PLP_Index: Number(position) || 'NA'
    }
    MOENGAGE_EVENT({
      eventName: 'HOME_PRODUCT_LIST_CLICK',
      payload: payload
    })
    GTAG_EVENT({
      eventName: 'HOME_PRODUCT_LIST_CLICK',
      payload: payload
    })
  }

  const headerBaseStyle = {
    background: "#fff",
    borderBottom: "1px solid #eee",
    padding: "10px 12px",
    fontWeight: 600,
  };
  const headerFixedStyle = isFixed
    ? {
        position: "fixed",
        top: OFFSET_TOP,
        left: 0,
        right: 0,
        zIndex: 100,
        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
      }
    : {};

  return (
    <div ref={containerRef} className="infinite-scroll-container">
      {/* Sticky header (fixed only while this widget is in view) */}
      <div ref={headerRef} style={{ ...headerBaseStyle, ...headerFixedStyle }}>
        {checkCache && catIds && catIds?.length > 0 && (
          <div className="category-scroll">
            {totalCategories && totalCategories.length > 1 && (
              <div
                className={`category-pallet ${
                  catIds && catIds.length > 1 ? "active" : ""
                }`}
                onClick={() => handleCategoryClick(totalCategories)}
              >
                <span>All</span>
              </div>
            )}
            {Array.isArray(catInfo) &&
              catInfo.map((obj) => (
                <div
                  key={obj.id}
                  className={`category-pallet ${
                    catIds && catIds.length === 1 && catIds[0] === obj.id
                      ? "active"
                      : ""
                  }`}
                  onClick={() => handleCategoryClick([obj.id], obj)}
                >
                  <span>{obj.category}</span>
                </div>
              ))}
          </div>
        )}
      </div>

      {/* Spacer to prevent layout jump when header becomes fixed */}
      <div style={{ height: isFixed ? headerH : 0 }} />

      <div style={{ margin: "10px" }}>
        <div className="row">
          {productList && productList.length > 0 ? (
            productList.map((product, prdIndex) => (
              <div
                key={product.id + product.name}
                className="col-6 col-md-6 col-lg-3 mb-3" // 2 per row on mobile/tablet, 4 per row on desktop
                onClick={() => handleEvent(product, prdIndex)}
              >
                <ImgBlock
                  product={product}
                  isExclusive={isExclusive}
                  isDesktop={isDesktop}
                  prdIndex={prdIndex}
                />
              </div>
            ))
          ) : (
            <div className={`col-12 text-center ${page === 1 ? 'spiner-center' : ''}`}>
              {catIds && catIds.length > 0 && isLoading && (
                <img
                  src={`${staticImgServer}assets/spinner-3.gif`}
                  className="spinner-3"
                  id="spinLoader"
                  alt="Loader"
                />
              )}
            </div>
          )}

          {isLoading && productList?.length > 1 && (
            <div className={`col-12 text-center ${page === 1 ? 'spiner-center' : ''}`}>
              <img
                src={`${staticImgServer}assets/spinner-3.gif`}
                className="spinner-3"
                id="spinLoader1"
                alt="Loader"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/react-component/homeListing.jsx